import {
  isLeCruiseSavedItemData,
  type LeCruiseSavedItemData,
  type TransportConnection,
  type TransportOption,
} from 'tripPlanner/api/types'

type CruiseTransportOption = TransportOption & {
  savedItemData: LeCruiseSavedItemData
}

function isCruiseTransportOption(option: TransportOption): option is CruiseTransportOption {
  return isLeCruiseSavedItemData(option.savedItemData)
}

export function getCruiseTransportOption(transport: TransportConnection): CruiseTransportOption | undefined {
  return transport.options.find(isCruiseTransportOption)
}

export function isFlightTransportOption(option: TransportOption): boolean {
  const normalisedType = option.type?.toLowerCase().replace(/[_\s]/g, '')
  return normalisedType === 'flight' || normalisedType === 'leflight' || normalisedType === 'chatflight'
}
